
/* Audio46: accessible add-to-cart confirmation
   Works on product and collection pages. */
(function () {
  'use strict';

  function init() {
    var dialog = document.getElementById('successDrawer');
    if (!dialog) return;

    var active = false;
    var lastTrigger = null;
    var returnFocus = null;

    var focusableSelector = [
      'a[href]:not([tabindex="-1"])',
      'button:not([disabled]):not([tabindex="-1"])',
      'input:not([disabled]):not([tabindex="-1"])',
      'select:not([disabled]):not([tabindex="-1"])',
      'textarea:not([disabled]):not([tabindex="-1"])',
      '[tabindex="0"]'
    ].join(',');

    function visible() {
      return window.getComputedStyle(dialog).display !== 'none';
    }

    function cancelAutoClose() {
      if (window.ab && window.ab.drawerTimeout != null) {
        clearTimeout(window.ab.drawerTimeout);
        window.ab.drawerTimeout = null;
      }
      if (window.drawerTimeout != null) {
        clearTimeout(window.drawerTimeout);
        window.drawerTimeout = null;
      }
    }

    function focusables() {
      return Array.prototype.filter.call(
        dialog.querySelectorAll(focusableSelector),
        function (element) {
          return element.getClientRects().length > 0 &&
            window.getComputedStyle(element).visibility !== 'hidden';
        }
      );
    }

    function focusElement(element) {
      if (!element || typeof element.focus !== 'function') return;
      try {
        element.focus({ preventScroll: true });
      } catch (e) {
        element.focus();
      }
    }

    function syncVisibility() {
      if (visible() && !active) {
        active = true;
        returnFocus = lastTrigger && lastTrigger.isConnected
          ? lastTrigger
          : document.activeElement;
        cancelAutoClose();
        focusElement(dialog);
      } else if (!visible() && active) {
        active = false;
        if (returnFocus && returnFocus.isConnected) {
          focusElement(returnFocus);
        }
        returnFocus = null;
        lastTrigger = null;
      }
    }

    function closeDialog() {
      if (!active) return;

      active = false;
      cancelAutoClose();

      if (window.jQuery) {
        window.jQuery(dialog).stop(true, true).hide();
      } else {
        dialog.style.display = 'none';
      }

      document.body.classList.remove('showOverly');

      if (returnFocus && returnFocus.isConnected) {
        focusElement(returnFocus);
      }

      returnFocus = null;
      lastTrigger = null;
    }

    document.addEventListener('click', function (event) {
      var element = event.target;
      if (!element || !element.closest) return;

      var trigger = element.closest(
        '.product-form__cart-submit, .add-to-cart, [data-a46-sticky-add]'
      );

      if (trigger && (event.isTrusted || !lastTrigger)) {
        lastTrigger = trigger;
      }
    }, true);

    document.addEventListener('click', function (event) {
      if (!active || !event.target || !event.target.closest) return;

      if (event.target.closest(
        '#successDrawer .closeDrawer, ' +
        '#successDrawer .continue-shopping, .modalOverly'
      )) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeDialog();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (!active) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeDialog();
      } else if (event.key === 'Tab') {
        var items = focusables();

        if (!items.length) {
          event.preventDefault();
          focusElement(dialog);
          return;
        }

        var first = items[0];
        var last = items[items.length - 1];

        if (event.shiftKey &&
            (document.activeElement === first ||
             document.activeElement === dialog)) {
          event.preventDefault();
          focusElement(last);
        } else if (!event.shiftKey &&
                   (document.activeElement === last ||
                    document.activeElement === dialog)) {
          event.preventDefault();
          focusElement(first);
        }
      }
    }, true);

    document.addEventListener('focusin', function (event) {
      if (active &&
          !dialog.contains(event.target) &&
          event.target !== dialog) {
        focusElement(dialog);
      }
    }, true);

    new MutationObserver(syncVisibility).observe(dialog, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    syncVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
